module.exports = __webpack_public_path__ + "videos/3d-transform_jp.b7b3451.mp4";